import React, { FC, useEffect, useState } from 'react';
import { Pagination, PaginationItem, Stack, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { TSelector, useSelector } from '../../hooks';
import { IPagination } from '../../redux/draws/get-winners.handler';

interface ICustomPaginationProps {
    pageChangeHandler: (page: number) => void;
    selector: TSelector<IPagination | null>;
}

export const CustomPagination: FC<ICustomPaginationProps> = ({ pageChangeHandler, selector }) => {
    const pagination = useSelector(selector);
    const [currentPage, setCurrentPage] = useState(pagination?.currentPage ?? 1);

    const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
        if (page !== currentPage) {
            setCurrentPage(page);
            pageChangeHandler(page);
        }
    };

    useEffect(() => {
        setCurrentPage(pagination?.currentPage ?? 1);
    }, [pagination?.currentPage]);

    if (!pagination || pagination.totalItems === 0 || pagination.totalPages < 2)
        return <></>;

    return (
        <Stack spacing={2} alignItems="center" mt={3}>
            <Pagination
                count={ pagination.totalPages }
                page={currentPage}
                onChange={ handlePageChange }
                variant="outlined"
                shape="rounded"
                color="primary"
                siblingCount={0}
                renderItem={(item) => (
                    <PaginationItem
                        slots={{ previous: ArrowBack, next: ArrowForward }}
                        {...item}
                    />
                )}
            />

            <Typography variant="body2" color="text.secondary">
                Показано {(currentPage - 1) * pagination.itemsPerPage + 1}-
                {Math.min(currentPage * pagination.itemsPerPage, pagination.totalItems)} из{' '}
                {pagination.totalItems}
            </Typography>
        </Stack>
    );
};